<h2>{{ customerId() ? 'Clients of customer' : 'Clients' }}</h2>
<div class="buttons">
  @if (customerId()) {
  <button mat-raised-button (click)="addClient()" color="primary">Add client</button>
  } @else {
  <mat-checkbox [ngModel]="isUnassignedClients()" (ngModelChange)="isUnassignedClients.set($event); updateUnassignedClients()">Unassigned Clients</mat-checkbox>
  }
</div>
<mat-form-field class="full">
  <mat-label>Filter</mat-label>
  <input matInput (keyup)="filter(input.value)" #input />
</mat-form-field>
<div class="mat-elevation-z8">
  @if (isUnassignedClients()) {
  <da-unassigned-client-table [filter]="input.value"></da-unassigned-client-table>
  } @else {
  <table mat-table [dataSource]="clientsOfCustomerService" matSort (matSortChange)="onSort($event)">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
      <td mat-cell *matCellDef="let row">{{ row.clientId }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="customerName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
      <td mat-cell *matCellDef="let row">{{ row.customerName }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef class="action"></th>
      <td mat-cell *matCellDef="let row" class="action">
        @if (row.customerId) {
        <button mat-icon-button color="warn" (click)="removeClient($event, row)">
          <mat-icon>close</mat-icon>
        </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  @if (clientsOfCustomerPaginated()) {
  <mat-paginator
    [length]="clientsOfCustomerPaginated().totalCount"
    [pageSize]="clientsOfCustomerService.pageSize"
    [pageIndex]="clientsOfCustomerService.page - 1"
    [pageSizeOptions]="[5, 10, 25, 100]"
    (page)="onPage($event)"
  >
  </mat-paginator>
  } }
</div>
